import { DeviceModel } from '@shure/shared/angular/data-access/system-api/models';

import { LightsImage } from '../plugin';

export abstract class LightsImageProvider {
	public abstract getLightsImage(model: DeviceModel): LightsImage | undefined;
}
